import { FC } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import styled from 'styled-components';

import { ReactComponent as ImgIcon } from '@/assets/icons/img-placeholder-gray.svg';
import { ReactComponent as ReelIcon } from '@/assets/icons/reel.svg';

const Img = styled(LazyLoadImage)`
  width: 108px;
  height: 61px;
  object-fit: cover;
`;

const Placeholder = styled(Img)`
  background: ${({ theme }) => theme.colors.grayscaleLight};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.white};
  border: solid 1px ${({ theme }) => theme.colors.lightGray};
  min-height: 49px;
`;

interface Props {
  src?: string;
  alt?: string;
  className?: string;
  type?: 'image' | 'reel';
}

const Image: FC<Props> = ({ src, className, alt = '', type = 'image' }) => {
  if (src) {
    return <Img src={src} alt={alt} className={className} />;
  }

  if (type === 'image') {
    return (
      <Placeholder as="div" className={className}>
        <ImgIcon />
      </Placeholder>
    );
  }

  if (type === 'reel') {
    return (
      <Placeholder as="div" className={className}>
        <ReelIcon />
      </Placeholder>
    );
  }

  return null;
};

export default Image;
